import React, { useState } from "react";
import "../../assets/scss/components/generic/navigationTag.scss";
import { Link } from "react-router-dom";
import { IListObj } from "../types/genericTypes";

export interface INavigationTagProps {
	defaultValue?: number | string; // default selected value
	tagList: Array<IListObj>; // list of all tags
	onSelect: (id: string | number) => void; // the function to be called onSelect
}

const NavigationTag: React.FC<INavigationTagProps> = (props: INavigationTagProps) => {
	/**
	 * state and function for selectedValue
	 * selectedValue type is number | string
	 * setSelectedValue(number | string)
	 */
	const [selectedValue, setSelectedValue] = useState(props.defaultValue);

	React.useEffect(() => {
		setSelectedValue(props.defaultValue);
	}, [props.defaultValue]);
	/**
	 * called when user selects a tag
	 * @param value id of the selected tag
	 * @returns onSelect prop passed from parent
	 */
	function tagSelected(value: string | number) {
		setSelectedValue(value);
		return props.onSelect(value);
	}

	return (
		<ul className="tag_navigation_content">
			{props.tagList.map((tag) => (
				<li className={"tag" + (tag.value === selectedValue ? " active" : "")} key={tag.value} onClick={() => tagSelected(tag.value)}>
					{tag.href && <Link to={tag.href}>{tag.display}</Link>}
					{!tag.href && tag.display}
				</li>
			))}
		</ul>
	);
};

export default NavigationTag;
